class Carousel extends HTMLElement {
  constructor() {
    super();

    this.active = this.querySelectorAll('.gallery-slide').length > 1;

    this.tickerSpeed = 1;
    this.isPaused = false;
  }

  connectedCallback() {
    this.addEventListener('mouseenter', this.pause.bind(this), false);
    this.addEventListener('focusin', this.pause.bind(this), false);
    this.addEventListener('mouseleave', this.play.bind(this), false);
    this.addEventListener('focusout', this.play.bind(this), false);

    this.init();
  }

  disconnectedCallback() {
    if(this.active) {
      this.flkty.off('staticClick', this.clickNav.bind(this));
      this.flkty.destroy();
    }
  }

  update() {

    if (this.isPaused) return;
    if(this.active) {
      this.flkty.x = (this.flkty.x - this.tickerSpeed) % this.flkty.slideableWidth;
      this.flkty.selectedIndex = this.flkty.dragEndRestingSelect();
      this.flkty.updateSelectedSlide();
      this.flkty.settle(this.flkty.x);
    }
    window.requestAnimationFrame(this.update.bind(this));
  };

  pause() {
    this.isPaused = true;
  };

  play() {
    if (this.isPaused) {
      this.isPaused = false;
      window.requestAnimationFrame(this.update.bind(this));
    }
  };

  init() {
    if(this.active) {
      this.flkty = new Flickity(this, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        contain: true,
        wrapAround: true,
        autoPlay: false,
        cellSelector: '.gallery-slide',

        selectedAttraction: 0.015,
        friction: 0.25
      });
      this.flkty.on('staticClick', this.clickNav.bind(this));
      this.flkty.on('dragStart', () => { this.isPaused = true; });
      this.flkty.x = 0;
    }

    this.update();

    // this.lazyloadAnimation();
    this.media = this.querySelectorAll('.is-selected img, .is-selected video');
  }

  clickNav(e) {
    const xCoordInClickTarget = e.clientX - this.getBoundingClientRect().left;

    if (this.offsetWidth / 2 > xCoordInClickTarget) {
      this.flkty.previous();
    } else {
      this.flkty.next();
    }
  }
}
customElements.define('carousel-module', Carousel);
